import { useEffect, useState } from 'react'
import create from 'zustand'
import isEmpty from 'lodash/isEmpty'

type SearchStore<T = unknown> = {
  searchData: Record<string, T>
  setData: (key: string, value: T) => void
}

const useSearchStore = create<SearchStore>((set) => ({
  searchData: {},
  setData: (key, value) => {
    set((v) => ({
      searchData: {
        ...v.searchData,
        [key]: value,
      },
    }))
  },
}))

export const useConditionalPersistentState = <T,>(
  initialValue?: T,
  key?: string
): [T, (v: T) => void] => {
  const [value, setValue] = useState(initialValue)
  const { searchData, setData } = useSearchStore((store) => store)

  const setSearch = (v: T) => {
    if (key) {
      setData(key, v)
      return
    }
    setValue(v)
  }

  useEffect(() => {
    if (!isEmpty(initialValue) && key) {
      setSearch(initialValue as T)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return [key ? (searchData[key] as T) : (value as T), setSearch]
}
